import { useState, useEffect, useCallback } from 'react'
import base64url from 'base64url'
import { getFaceProfile } from '../services/advisors/getFaceProfile'
import '@ampdx/common-utils/src/bufferUtils'

const useFaceProfile = (): { advisorData: any; error: string | null; firstName: string | null } => {
  const [advisorData, setAdvisorData] = useState(null)
  const [error, setError] = useState<string | null>(null)
  const [firstName, setFirstName] = useState(null)

  const query = new URLSearchParams(window.location.search)
  const personalizationToken = query.get('PersonalizationToken')

  const fetchFaceProfile = useCallback(async (id: string) => {
    try {
      const advisorRes = await getFaceProfile({ id })
      if (!advisorRes.errors.length) {
        setAdvisorData(advisorRes.data)
      } else {
        setError('Error fetching face profile:' + advisorRes.errors)
      }
    } catch (error) {
      setError('Error initializing client:' + error)
    }
  }, [])

  useEffect(() => {
    if (personalizationToken) {
      const personalization = JSON.parse(base64url.decode(personalizationToken))
      if (personalization?.faceProfileId) {
        void fetchFaceProfile(personalization.faceProfileId)
      }
      if (personalization?.clientfirstName) {
        setFirstName(personalization.clientfirstName.toLowerCase())
      }
    }
  }, [fetchFaceProfile, personalizationToken])

  return { advisorData, error, firstName }
}

export { useFaceProfile }
